// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /event/days-with-games-list.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeEventDaysWithGamesListBody,
  typeEventDaysWithGamesListOutput200,
} from "../../sdk/event/postEventDaysWithGamesList";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildEventDaysWithGamesListQueryKey(
  payload: typeEventDaysWithGamesListBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`leagueId:${JSON.stringify(payload.leagueId)}`);
  queryKeySegments.push(`fromDay:${JSON.stringify(payload.fromDay)}`);
  queryKeySegments.push(`toDay:${JSON.stringify(payload.toDay)}`);
  queryKeySegments.push(`timeZone:${JSON.stringify(payload.timeZone)}`);
  return [
    "post:event:eventDaysWithGamesList",
    "svc:events-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeEventDaysWithGamesListOutput200,
    unknown,
    typeEventDaysWithGamesListOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useEventDaysWithGamesList(
  payload: typeEventDaysWithGamesListBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildEventDaysWithGamesListQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postEventDaysWithGamesList(payload),
    ...resolvedOptions,
  });
}
